module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-project-list-container"
  }, [(_vm.isLoading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('section', {
    staticClass: "c-project-list"
  }, [_c('ul', {
    staticClass: "c-project-list__list",
    class: {
      padded: _vm.padded
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      class: index <= 2 ? 'c-project-list__item c-project-list__item--featured' : 'c-project-list__item'
    }, [_c('router-link', {
      key: project.slug,
      staticClass: "c-project-list__link",
      style: ('background-image:url(' + project.featuredImageUrl + ')'),
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/work/' + project.slug : '/work/' + project.slug
      }
    }, [(index <= 2) ? _c('div', {
      staticClass: "c-project-list__link__skewy",
      style: ('transform: translateY(50%) skewY(' + _vm.randomSkew() + 'deg);')
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "c-project-list__image",
      attrs: {
        "src": project.featuredImageUrl,
        "alt": project.featuredImageAlt
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-project-list__link__content"
    }, [_c('h3', {
      staticClass: "c-project-list__title",
      domProps: {
        "innerHTML": _vm._s(project.title)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-project-list__client"
    }, [_vm._v(_vm._s(project.client))])])])], 1)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308f76e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectList.vue
// module id = 259
// module chunks = 0